import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Client } from '../models/client';
import { Paginator } from '../models/paginator';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

interface ClientResponse {
}

interface ClientsListResponse {
}

@Injectable()
export class ClientService {
  changed: EventEmitter<void> = new EventEmitter<void>();

  constructor(private http: HttpClient) {
  }


  get(): Observable<Paginator<Client>> {
    return this.http.get<any>(`${environment.apiUrl}/clients`)
      .pipe(
        map(json => {
          let clients = json.data.map(row => {
            return new Client(row);
          });
          return new Paginator<Client>(json.meta.pagination, clients);
        }));
  }

  find(id: number): Observable<Client> {
    return this.http.get<ClientResponse>(`${environment.apiUrl}/clients/${id}`)
      .pipe(
        map(json => {
          return Client.fromJson(json);
        }));
  }

  create(data: { name: string, slug: string }): Observable<Client> {
    let body = JSON.stringify(data);
    return this.http.post<ClientResponse>(`${environment.apiUrl}/clients`, body)
      .pipe(
        map(responseJson => {
          this.changed.emit();
          return Client.fromJson(responseJson);
        }));
  }

  update(client: Client, data: { name: string, slug: string }): Observable<Client> {
    let body = JSON.stringify(data);
    return this.http.put<ClientResponse>(`${client.url}`, body)
      .pipe(
        map(responseJson => {
          this.changed.emit();
          return Client.fromJson(responseJson);
        }));
  }

  deleteClient(client: Client): Observable<void> {
    return this.http.delete(`${client.url}`)
      .pipe(
        map(response => {
          return;
        }));
  }

  generateSlug(name: string) {
    return this.http.get<{ slug: string }>(`${environment.apiUrl}/clients/slug`, { params: { name: name } })
      .pipe(
        map(json => {
          return json.slug;
        }));
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/client.service.ts